export class NtPoint {
    public x: number = null;
    public y: number = null;

    public clear() {
        this.x = this.y = null;
    }
}
